export default (https) => ({
  async get() {
    const response = await https.get(`/general-settings`);
    return response.data;
  },

  async update(payload) {
    const response = await https.post(`/general-settings`, payload);
    return response.data;
  },
});

